import { api1C } from './api';

export const testService = () => api1C.post('test');